/* eslint-disable import/newline-after-import */
import React from 'react';
export default function Footer() {
  return (
    <footer className="snow-footer">
      <p>
        Snowy Hydro snow depth measurements. Spencers Creek is typically
        measured weekly or fortnightly during the snow season, while Deep Creek
        and Three-Mile Dam are measured less consistently, with gaps of up to
        three weeks between readings. Data is updated irregularly and should be
        considered indicative only.
      </p>
      <p className="snow-footer__source">
        Source:{' '}
        <a
          href="https://www.snowyhydro.com.au/generation/live-data/snow-depths/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Snowy Hydro
        </a>
      </p>
    </footer>
  );
}
